module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('google-map', {
    ref: "gm",
    attrs: {
      "sharer": _vm.sharerId,
      "show-lengend": _vm.showLegend,
      "map-style": "elevation",
      "show-sites": true,
      "legend": _vm.legend
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167e9566"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maps/SharerMap.vue
// module id = 1336
// module chunks = 0